export default __webpack_public_path__ + "static/media/author-page-image1.19c795ac.PNG";